// Considered: SchemaCardAtom — rejected because it's bound to schema entities with fixed slots; no view-type icon + localized-name + edit-affordance shape. See spec Reuse Audit.
import React from 'react';
import { useTranslation } from 'localization';
import { getLocalizedText } from '../../../utils/getLocalizedText';
import type { ContextViewRecord } from '../../../api/contextApi';
import './ContextViewCardMolecule.scss';

const VIEW_TYPE_ICONS: Record<string, string> = {
  atlas: 'pi pi-compass',
  treemap: 'pi pi-th-large',
  kanban: 'pi pi-server',
  table: 'pi pi-table',
  timeline: 'pi pi-calendar',
  custom: 'pi pi-circle',
};

export interface ContextViewCardMoleculeProps {
  view: ContextViewRecord;
  onOpen: (view: ContextViewRecord) => void;
  disabled?: boolean;
}

const ContextViewCardMolecule: React.FC<ContextViewCardMoleculeProps> = ({ view, onOpen, disabled }) => {
  const { t } = useTranslation();
  const viewName = getLocalizedText(view.name);
  const viewType = view.view_type;
  const icon = VIEW_TYPE_ICONS[viewType] ?? 'pi pi-circle';

  return (
    <button
      className={`context-view-card-molecule context-view-card-molecule--${viewType}${disabled ? ' context-view-card-molecule--disabled' : ''}`}
      onClick={() => !disabled && onOpen(view)}
      disabled={disabled}
      aria-label={viewName}
      type="button"
    >
      <div className="context-view-card-molecule__header">
        <span className="context-view-card-molecule__icon-tile">
          <i className={icon} aria-hidden="true" />
        </span>
        <div className="context-view-card-molecule__info">
          <span className="context-view-card-molecule__name">{viewName}</span>
          <span className="context-view-card-molecule__type-label">
            {t(`context.viewEditor.viewTypes.${viewType}`)}
          </span>
        </div>
      </div>

      <div className="context-view-card-molecule__divider" aria-hidden="true" />

      <div className="context-view-card-molecule__footer">
        <span className="context-view-card-molecule__edit-action">
          {t('context.editor.views.editView')}
          <i className="pi pi-arrow-right" aria-hidden="true" />
        </span>
      </div>
    </button>
  );
};

export default ContextViewCardMolecule;
